<template lang="">
  <div>
    <h4>새 패키징 타입 등록</h4>
    <b-form>
      <b-form-group
        label="이름"
        label-for="nameInput"
        invalid-feedback="필수 입력 항목입니다."
      >
        <b-form-input id="nameInput" required></b-form-input>
      </b-form-group>
      <b-form-group
        label="타입코드"
        label-for="typecodeInput"
        invalid-feedback="필수 입력 항목입니다."
      >
        <b-form-input
          id="typecodeInput"
          required
          v-model="facilityId"
        ></b-form-input>
        <b-button-group class="text-right mb-2 mt-1">
          <b-button
            @click="createId"
            squared
            style="border: 0rem"
            variant="outline-primary"
            >KFT Food Trust™ 패키징 타입 식별자 생성</b-button
          >
        </b-button-group>
      </b-form-group>
      <b-form-group label="사이즈" label-for="sizeInput">
        <b-form-input id="sizeInput"></b-form-input>
      </b-form-group>
      <b-form-group label="수량" label-for="quantityInput">
        <b-form-input id="quantityInput" type="number"></b-form-input>
      </b-form-group>
      <b-form-group label="단위">
        <b-form-select :options="uomOptions"></b-form-select>
      </b-form-group>
      <b-form-group label="이미지">
        <b-form-file
          v-model="image"
          placeholder="파일을 선택하세요..."
        ></b-form-file>
        <b-img v-if="hasImage" :src="imageSrc"></b-img>
      </b-form-group>

      <b-button style="width: 150px" squared>제출하기</b-button>
    </b-form>
  </div>
</template>
<script>
const base64Encode = (data) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export default {
  components: {
    name: "AddNewPackageModal",
  },
  props: {},
  data() {
    return {
      image: null,
      imageSrc: null,
      uomOptions: [
        { text: "unit", value: "unit" },
        { text: "case", value: "case" },
        { text: "killogram", value: "killogram" },
        { text: "ton", value: "ton" },
      ],
      facilityId: "",
    };
  },
  methods: {
    createId(newFacilityId) {
      newFacilityId = this.facilityId.concat(
        "99999.",
        Math.random().toString(36).substring(2, 8)
      );
      return (this.facilityId = newFacilityId);
    },
  },
  computed: {
    hasImage() {
      return !!this.image;
    },
  },
  watch: {
    image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then((value) => {
              this.imageSrc = value;
            })
            .catch(() => {
              this.imageSrc = null;
            });
        } else {
          this.imageSrc = null;
        }
      }
    },
  },
};
</script>
<style lang=""></style>
